// extracted by mini-css-extract-plugin
export default {"mediaPlaceholder":"MediaPreview_mediaPlaceholder__5qduE","swipeIndicator":"MediaPreview_swipeIndicator__3fau6","swipeToLoad":"MediaPreview_swipeToLoad__l+iv+"};